module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  "use strict";

  r.r(t);
  var n = {
    statusCodes: [401]
  };

  t.default = function e(t, r) {
    var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        u = t.interceptors.response.use(function (e) {
      return e;
    }, function (s) {
      var i = o.hasOwnProperty("statusCodes") && o.statusCodes.length ? o.statusCodes : n.statusCodes;
      if (!s.response || s.response.status && -1 === i.indexOf(+s.response.status)) return Promise.reject(s);
      t.interceptors.response.eject(u);
      var c = r(s),
          f = t.interceptors.request.use(function (e) {
        return c.then(function () {
          return e;
        });
      });
      return c.then(function () {
        return t.interceptors.request.eject(f), t(s.response.config);
      }).catch(function (e) {
        return t.interceptors.request.eject(f), Promise.reject(e);
      }).finally(function () {
        return e(t, r, o);
      });
    });
    return t;
  };
}]);